import { gql } from '@apollo/client';

export const GET_ANALYTICS_UNMODERATED = gql`
  query Analytics($projectId: ID!, $segmentId: ID) {
    analytics(projectId: $projectId, segmentId: $segmentId) {
      unmoderatedAnalytics(projectId: $projectId, segmentId: $segmentId) {
        id
        label
        questionType
        questionOrder
        leftLabel
        rightLabel
        total
        matrixType
        averageTime
        imageUrl
        videoUrl
        writtenAndTranscriptAnswers {
          testerId
          firstName
          valueText
          transcriptText
          videoStartTime
          videoEndTime
          timeOnAnswer
        }
        options {
          id
          label
          count
          imageUrl
        }
        others {
          firstName
          valueText
        }
      }
    }
  }
`;
